/** Small shared renderers for roster rows (table, drawer, dashboard). */
import { ORIGIN_COLOR, ORIGIN_LABEL, ORIGIN_TONE, STATUS_LABEL, STATUS_TEXT_COLOR, STATUS_TONE } from '@/lib/labels';
import type { RosterOrigin, RosterStatus } from '@/types';

const TONE_CLASS = { neutral: 'chip-neutral', success: 'chip-success', warning: 'chip-warning', danger: 'chip-danger', info: 'chip-info' } as const;

export function OriginTag({ origin }: { origin: RosterOrigin }) {
  return <span className={`tag ${TONE_CLASS[ORIGIN_TONE[origin]]}`}>{ORIGIN_LABEL[origin] ?? origin}</span>;
}

export function StatusTag({ status }: { status: RosterStatus }) {
  return <span className={`tag ${TONE_CLASS[STATUS_TONE[status]]}`}>{STATUS_LABEL[status] ?? status}</span>;
}

export function StatusText({ status }: { status: RosterStatus }) {
  return <span style={{ color: STATUS_TEXT_COLOR[status] }}>{STATUS_LABEL[status] ?? status}</span>;
}

export function Swatch({ origin }: { origin: RosterOrigin }) {
  return <span className="swatch" style={{ background: ORIGIN_COLOR[origin] }} aria-hidden="true" />;
}

export function ToneTag({ tone, children }: { tone: keyof typeof TONE_CLASS; children: React.ReactNode }) {
  return <span className={`tag ${TONE_CLASS[tone]}`}>{children}</span>;
}
